import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InAppBrowser, InAppBrowserOptions, InAppBrowserEvent } from '@ionic-native/in-app-browser/ngx'
import { NavigationExtras, Router } from '@angular/router';
import { WebIntentService } from "../../services/web-intent.service";
import { isPlatform, NavController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss'],
})

export class PaymentModalComponent implements OnInit {

  @Input() modalObj: any;
  itsSafe: any;
  paymentFrame: any;
  orderId;

  options: InAppBrowserOptions = {
    location: 'no',//Or 'no' 
    hidden: 'no', //Or  'yes'
    zoom: 'no',//Android only ,shows browser zoom controls 
    hideurlbar: 'yes',//Or 'no'
    toolbar: 'no',
    footer: 'no',
    // clearcache: 'yes', 
  };

  constructor(public activeModal: NgbActiveModal, private _sanitizer: DomSanitizer, private iab: InAppBrowser, private router: Router,
    public webIntentService: WebIntentService, private platform: Platform) { }

  ngOnInit() {
    console.log(this.modalObj);
    this.orderId = this.modalObj.orderId
    let netBnkBrowser
    if (this.modalObj && this.modalObj.hasOwnProperty('type') && this.modalObj?.type === 'netBnk') {
      const options: InAppBrowserOptions = {
        location: this.modalObj.paymentType ? 'no' : 'yes',
        hidden: 'yes',
        zoom: 'yes',
        footer: 'no',
        toolbar: this.modalObj.paymentType ? 'no' : 'yes',
        closebuttoncaption: ' close',
        closebuttoncolor: 'black',
        hardwareback: 'yes',
        hidenavigationbuttons: 'yes',
        toolbarcolor: '#efefef',
        lefttoright: isPlatform('ios') ? 'no' : 'yes',
        hideurlbar: 'yes',
        toolbarposition: 'top'

      }

      netBnkBrowser = this.iab.create('data:text/html,' + encodeURIComponent(this.modalObj.res), "_blank", options)
      netBnkBrowser.hide()
    } else if (this.modalObj && this.modalObj.hasOwnProperty('type') && this.modalObj?.type === 'upi') {
      const target = '_system';
      let browser = this.iab.create(this.modalObj.updatedDeeplink, target, this.options);
      this.platform.resume.subscribe(async () => {
        console.log("app resume event");
        if (this.activeModal && browser) {
          this.activeModal.close('closed');
          browser = null
        }
      });
    }
    if (netBnkBrowser) {

      netBnkBrowser.on('loadstart').subscribe((ev: InAppBrowserEvent) => {
        console.log('loadstart load called', ev);
      })
      netBnkBrowser.on('loaderror').subscribe((ev: InAppBrowserEvent) => {
        console.log('loaderror load called');
        netBnkBrowser.close();
      })
      // browser.on('beforeload').subscribe((ev: InAppBrowserEvent) => {
      //   console.log('before load called');
      // })
      // browser.on('message').subscribe((ev: InAppBrowserEvent) => {
      //   console.log('message load called');
      // })
      // browser.on('customscheme').subscribe((ev: InAppBrowserEvent) => {
      //   console.log('customscheme load called');
      // })
      netBnkBrowser.on('exit').subscribe((ev: InAppBrowserEvent) => {
        console.log(ev);
        netBnkBrowser.close();
        setTimeout(() => {
          this.activeModal.close(this.orderId);
        }, 500)
      })

      // netBnkBrowser.on('message').subscribe(event => {
      //   console.log(event)
      //   if (event.data.msg === 'close') {
      //     netBnkBrowser.close();
      //   }
      // })
      netBnkBrowser.on('loadstop').subscribe((ev: InAppBrowserEvent) => {
        console.log('in app stopped loading');
        netBnkBrowser.show();
        const search = new URL(ev.url).search
        console.log(search)
        console.log(new URLSearchParams(search).get('paymentMethod'), new URLSearchParams(search).get("status"))
        if (new URLSearchParams(search).get('paymentMethod') && new URLSearchParams(search).get("status")) {
          console.log(ev)
          this.orderId = new URLSearchParams(search).get("orderId");
          netBnkBrowser.close();
        }else if(new URLSearchParams(search).get("ORDER_ID")){
          this.orderId = new URLSearchParams(search).get("ORDER_ID");
          netBnkBrowser.close();
          setTimeout(() => {
            this.activeModal.close(this.orderId);
          }, 500);
        }
      })
    }
  }

  transform(v: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustResourceUrl(v);
  }
}
     // netBnkBrowser.executeScript({
      //   code: "(function() { \
      //   var body = document.querySelector('body'); \
      //   var div = document.createElement('div'); \
      //   var button = document.createElement('p');\
      //   button.setAttribute('id','customBackbtn');\
      //   button.innerHTML = 'Close'; \
      //   div.classList.add('back_btn'); \
      //   div.appendChild(button);\
      //   body.appendChild(div);  } )(   );" });
      //   netBnkBrowser.executeScript({   code: "document.getElementById('customBackbtn').onclick = function() {window.close();}"})
      // // netBnkBrowser.executeScript({ code: "(function() { var body = document.querySelector('body'); var button = document.createElement('div'); button.setAttribute('id','customBackbtn');button.innerHTML = 'Close'; button.classList.add('back_btn'); body.appendChild(button);  } )(   );" },);
      // netBnkBrowser.insertCSS({ code: ".back_btn{position:absolute;width:100%;background:#efefef;box-shadow: 0 0 8px #d4d5d9;top:0px;padding:10px 16px} #customBackbtn{font-size:14px;font-weight:bold;font-family: 'Avenir-heavy' !important;padding:4px; margin:0px;color:black; display:inline-block;} body{margin-top:40px}" });
      // console.log(ev);